<template>
  <div class="" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="lbl-title">Novo número</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="resetForm">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="errorMessage" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>
          <form class="needs-validation" novalidate>
            <div class="form-group">
              <label for="txt-nome">Nome</label>
              <input type="text" class="form-control" id="txt-nome"
                placeholder="Digite o nome para identificar o telefone" required v-model="name">
              <div class="invalid-feedback">
                O nome não pode ser vazio.
              </div>
            </div>
            <div class="form-group">
              <label for="txt-numero">Número</label>
              <input type="text" class="form-control" id="txt-numero" required
                pattern="^\+55\s?\(?\d{2}\)?\s?\d{4,5}-?\d{4}$" v-mask="['+## (##) #####-####']" v-model="number">
              <div class="invalid-feedback">
                Por favor, forneça um número de telefone válido.
              </div>
            </div>
            <div class="form-group">
              <label for="cmb-provider">Provedor</label>
              <select class="form-control" id="cmb-provider" required v-model="provider">
                <option selected disabled value="">Escolha...</option>
                <option value="WHATS_META">Meta</option>
                <option value="WHATS_WPP">Whatsapp</option>
              </select>
              <div class="invalid-feedback">
                Por favor, selecione um provedor.
              </div>
            </div>
            <div class="form-group">
                <label for="txt-metaNumber">URL API</label>
                <input type="text" class="form-control" id="txt-metaNumber" required v-model="urlAPI" placeholder="https://api.nxzap.com.br">
                <div class="invalid-feedback">
                  Insira um URL API válido.
                </div>
              </div>
            <div v-if="provider === 'WHATS_META'">
              <div class="form-group">
                <label for="txt-metaToken">Token da META</label>
                <input type="text" class="form-control" id="txt-metaToken" required v-model="metaToken">
                <div class="invalid-feedback">
                  Por favor, insira um Token válido.
                </div>
              </div>
              <div class="form-group">
                <label for="txt-metaNumber">Número META</label>
                <input type="text" class="form-control" id="txt-metaNumber" required v-model="metaNumber">
                <div class="invalid-feedback">
                  Insira um número META válido.
                </div>
              </div>
              <div class="form-group">
                <label for="txt-metaNumber">URL META</label>
                <input type="text" class="form-control" id="txt-metaNumber" required v-model="metaURL" placeholder="https://graph.facebook.com/v20.0/">
                <div class="invalid-feedback">
                  Insira um url META válido.
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-third btn-sm" @click="handleAdd" v-b-tooltip.hover :title="'Adicinar'">
            <i class="fa "></i><span class="d-md-down-none">Adicionar</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NumRepository from '@/shared/http/repositories/access/cadastroNum.js'
import defaultbutton from '@/components/UI/button/defaultButton.vue'

export default {
  name: 'ProviderAdd',
  data () {
    return {
      id_provider: null,
      number: null,
      name: null,
      type: null,
      active: 1,
      apinumber: null,
      metaNumber: null,
      metaToken: null,
      provider: null,
      errorMessage: null,
      urlAPI: null,
      metaURL: null
    }
  },
  components: {
    defaultbutton
  },
  methods: {
    validateForm () {
      const form = document.querySelector('.needs-validation')
      if (form.checkValidity() === false) {
        form.classList.add('was-validated')
        this.errorMessage = null
        return false
      }
      return true
    },
    resetForm () {
      console.log('oi')
      this.$emit('clicked-close')
    },
    async clear () {
      this.name = ''
      this.number = ''
      this.apinumber = ''
      this.metaNumber = ''
      this.metaToken = ''
      this.urlAPI = ''
      this.metaURL = ''
    },
    async add () {
      const requestConfig = {
        name: this.name,
        number: this.number.replaceAll(/\D/g, ''),
        active: this.provider === 'WHATS_META' ? 1 : 0,
        type: this.provider,
        id_provider: null,
        apinumber: this.apinumber,
        metaNumber: this.metaNumber,
        metaToken: this.metaToken,
        urlAPI: this.urlAPI,
        metaUrl: this.metaURL
      }
      try {
        const result = await NumRepository.create(requestConfig)
        if (result.data === '') {
          this.errorMessage = 'Número já cadastrado'
        } else {
          this.clear()
          this.$emit('carregar')
        }
      } catch (error) {
        this.errorMessage = 'Erro ao cadastrar'
      }
    },
    handleAdd () {
      if (this.validateForm()) {
        this.add()
      }
    }
  }
}
</script>

<style scoped>
.modal-header {
  background-color: #04A791;
}

.modal-title {
  color: white;
  font-weight: bold;
}
label{
  font-weight: bold;
}

.modal-body {
  min-height: 35vh;
  overflow-y: auto;
  min-width:  40vh;
}

</style>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/provedores/add/ProvedorAdd.vue